import { useTranslation } from 'react-i18next';
import { getLocaleDir } from './catalogLocales';

/**
 * The active locale's direction, resolved exactly like the <html dir> effect in config.ts:
 * the backend-published direction wins, and i18next's own table is the fallback.
 *
 * Anything that needs direction as a *value* (rather than a CSS logical property) must read
 * it from here, so there is one source of truth. Re-renders on language change.
 */
export const useLocaleDirection = (): 'ltr' | 'rtl' => {
  const { i18n } = useTranslation();
  const lng = i18n.language || 'en';
  return getLocaleDir(lng) ?? (i18n.dir(lng) as 'ltr' | 'rtl');
};
